import React from "react";
import { useHistory } from "react-router-dom";

import { DEFAULT_PAGE } from "constants/routes.constants";

import styles from "../sidebar.module.css";
import logoImg from "assets/images/logo.svg";

const Logo: React.FC = () => {
  const history = useHistory();

  const handleRedirectHome = () => {
    history.push(DEFAULT_PAGE.path);
  };

  return (
    <div className={styles.logo} onClick={handleRedirectHome}>
      <img src={logoImg} alt="" />
      Esp Hub
    </div>
  );
};

export default Logo;
